import { supabase } from '@/lib/supabase';
import type { Branch } from '../stores/branch-store';
import type { SupabaseClient } from '@/lib/supabase';

// Check if Supabase is properly configured
let supabaseUrl = import.meta.env.VITE_SUPABASE_URL || import.meta.env.SUPABASE_URL || '';
if (supabaseUrl.includes('=')) {
  supabaseUrl = supabaseUrl.split('=')[1] || '';
}
const isSupabaseConfigured = supabaseUrl.startsWith('https://') && supabaseUrl.includes('.supabase.co');

/**
 * Update an existing branch
 */
export async function updateBranch(
  id: string,
  branchData: Partial<Pick<Branch, 'name' | 'location' | 'phone' | 'lat' | 'lng' | 'is_main' | 'operating_hours'>>
): Promise<Branch> {
  if (!isSupabaseConfigured || !supabase) {
    // Return mock data for demo mode
    return {
      id,
      name: branchData.name || '',
      location: branchData.location || '',
      phone: branchData.phone || '',
      lat: branchData.lat,
      lng: branchData.lng,
      is_main: branchData.is_main || false,
      operating_hours: branchData.operating_hours,
    };
  }

  const supabaseClient = supabase as SupabaseClient;
  
  const updateData: Record<string, unknown> = {};
  
  if (branchData.name !== undefined) updateData.name = branchData.name;
  if (branchData.location !== undefined) updateData.location = branchData.location;
  if (branchData.phone !== undefined) updateData.phone = branchData.phone;
  if (branchData.lat !== undefined) updateData.lat = branchData.lat;
  if (branchData.lng !== undefined) updateData.lng = branchData.lng;
  if (branchData.is_main !== undefined) updateData.is_main = branchData.is_main;
  if (branchData.operating_hours !== undefined) updateData.operating_hours = branchData.operating_hours;

  const result = await supabaseClient
    .from('branches')
    .update(updateData as never)
    .eq('id', id)
    .select()
    .single();

  if (result.error) {
    console.error('Error updating branch:', result.error);
    throw new Error(result.error.message);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const branch: any = result.data;
  return {
    id: branch.id,
    name: branch.name,
    location: branch.location || '',
    phone: branch.phone || '',
    lat: branch.lat,
    lng: branch.lng,
    is_main: branch.is_main || false,
    operating_hours: branch.operating_hours,
  };
}
